module.exports = __webpack_public_path__ + "frontend/img/questionmark.addba2c6.svg";